module.exports = __webpack_public_path__ + "img/【诊改行动】变革创新，激情奋起！上电智联助力正式开启双菊汽配轻量级数字化改造项目.e750eb46.jpg";